import { render, staticRenderFns } from "./GrowerVoucher.vue?vue&type=template&id=55440bde&scoped=true&"
import script from "./GrowerVoucher.vue?vue&type=script&lang=js&"
export * from "./GrowerVoucher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55440bde",
  null
  
)

export default component.exports